<template>
    <div class="rp">
<!--        <div class="rp-title" style="margin-top: 0">发布渠道</div>-->

<!--      <Row :gutter="20">-->
<!--        <Col span="20">-->
<!--          <check-tag-group-->
<!--            v-model="channel"-->
<!--            style="display: inline-block"-->
<!--            color="primary"-->
<!--            :disabled="false"-->
<!--          >-->
<!--            <check-tag-->
<!--              v-for="item in this.channelList"-->
<!--              :name="item.id"-->
<!--              :key="item.id"-->
<!--            >{{ item.text }}</check-tag-->
<!--            >-->
<!--          </check-tag-group>-->
<!--        </Col>-->
<!--      </Row>-->





        <div class="rp-title" style="margin-top: 0">房源信息</div>
        <form-lookup
            style="width: 300px; margin: 6px 0"
            placeholder="选择房间"
            title="选择房间"
            :modalHeight="600"
            :modalWidth="900"
            @change="onHouseChange"
        >
            <select-publish-house
                :defaultHouseIds="defaultHouseIds"
                :unPublish="unPublish"
            ></select-publish-house>
        </form-lookup>
        <Table
            ref="mt"
            height="320"
            :formula="formula"
            :columns="columns"
            :data="selection"
        >
            <template #action="{ row, index }">
                <common-icon
                    type="ios-remove-circle-outline"
                    :size="22"
                    style="cursor: pointer"
                    @click.native="onRowDel(row, index)"
                ></common-icon>
            </template>
        </Table>
        <!-- 下架 -->
        <template v-if="unPublish">
            <div class="rp-title">下架提示</div>
            <div style="margin: 12px 0">
                下架后，无法恢复，请仔细核对下架房源
            </div>
        </template>
        <!-- 上架 -->
        <template v-else>
            <div class="rp-title">费用合计</div>
            <table class="rp-fe">
                <tr>
                    <td>总金额:</td>
                    <td class="rp-fe-num">¥{{ totalAmount | currency }}</td>
                    <td>原价总费用</td>
                </tr>
                <tr>
                    <td>优惠:</td>
                    <td class="rp-fe-num is-neg">
                        -¥{{ discountAmount | currency }}
                    </td>
                    <td>推广期间，费用全免</td>
                </tr>
                <tr>
                    <td>合计:</td>
                    <td class="rp-fe-num is-neg">
                        ¥<span class="rp-fe-sum">{{
                            sumAmount | currency
                        }}</span>
                    </td>
                    <td></td>
                </tr>
            </table>
        </template>
    </div>
</template>

<script>
import {
  marketRoomPublish,
  marketRoomUnPublish,
  marketRoomCheckPublish,
  batchPublishZwZhao, unPubHouseToZwZhao
} from "@/api/assets";
import SelectPublishHouse from '_vc/select-publish-house'
import { currency, round } from '_u/helper'

// 房间上架/下架
export default {
    name: 'room-publish',
    components: {
        SelectPublishHouse,
    },
    inject: {
        $modal: { default: null },
    },
    props: {
        // 默认选中的房间
        defaultHouseList: {
            type: Array,
            default: () => [],
        },
        // 是否下架操作
        unPublish: {
            type: Boolean,
            default: false,
        },
        curChannel: {
          type:[String, Number],
          default:0,
        },
    },
    data() {
        return {
            selection: [],
            // channel: [2],
            channelList: [],
        }
    },
    computed: {
        defaultHouseIds() {
            return this.selection.map((v) => v.id).join(',')
        },
        columns() {
            return [
                {
                    key: 'houseName',
                    minWidth: 140,
                    title: '房源名称',
                },
                {
                    key: 'rentText',
                    minWidth: 140,
                    title: '租金（元）',
                },
                {
                    key: 'commissionText',
                    minWidth: 140,
                    title: '佣金（元）',
                },
                {
                    key: 'commissionRemark',
                    minWidth: 140,
                    title: '佣金说明',
                },
                {
                    key: 'feeText',
                    minWidth: 140,
                    title: '费用小计（元）',
                },
                {
                    minWidth: 100,
                    title: '操作',
                    slot: 'action',
                },
                {
                  key: 'errorMessage',
                  minWidth: 140,
                  title: '校验结果',
                },
            ]
        },
        totalAmount() {
            return round(
                this.selection.reduce((acc, v) => (acc += v.fee || 0), 0),
                2
            )
        },
        discountAmount() {
            return round(this.totalAmount, 2)
        },
        sumAmount() {
            return round(this.totalAmount - this.discountAmount, 2)
        },
    },
    created() {
        this.selection = this.normalizeHouseList(this.defaultHouseList)
        this.buildChannelList()
    },
    mounted() {
        this.$modal.onBtnClick('confirm', (next, options) => {
          var currentChannel = this.curChannel

          //出房发布
          if (currentChannel == 1){
            var ids = ''

            this.$refs.mt
              .validate()
              .then(() => {
                if (this.selection.length <= 0) {
                  return Promise.reject({
                    msg: '房源不能为空',
                  })
                }
              })
              .then(() => {
                // 下架
                if (this.unPublish) {
                  ids = this.selection.map((v) => v.pubHouseId).join(',')
                }
                // 上架
                else {
                  ids = this.selection.map((v) => v.id).join(',')

                  // 上架前校验
                  return marketRoomCheckPublish(ids)
                }
              })
              .then((res) => {
                // 校验结果处理
                if (res) {
                  var errors = (res.data.list || []).filter(
                    (v) => v.msg !== 'ok'
                  )

                  if (errors.length) {
                    // 错误信息回填
                    errors.forEach((e) => {
                      var row = this.selection.find(
                        (r) => r.id == e.id
                      )

                      if (row) {
                        row.errorMessage = e.msg.includes('属性')
                          ? '房间信息不完整，无法发布'
                          : e.msg
                      }
                    })
                    return Promise.reject()
                  }
                }

                if (this.unPublish) {
                  // 下架
                  return marketRoomUnPublish(ids)
                } else {
                  // 上架
                  return marketRoomPublish(ids)
                }
              })
              .then((res) => {
                // 下架
                if (this.unPublish) {
                  var errors = (res.data.list || []).filter(
                    (v) => v.msg !== 'ok'
                  )

                  if (errors.length) {
                    // 错误信息回填
                    errors.forEach((e) => {
                      var row = this.selection.find(
                        (r) => r.pubHouseId == e.id
                      )

                      if (row) {
                        row.errorMessage = e.msg
                      }
                    })
                    return Promise.reject()
                  }
                }
              })
              .catch((e) => {
                options.closeModal = false
              })
              .finally(() => next())
          }else if (currentChannel == 2){
            console.log("找房发布")
            var houseIds = this.selection.map((v) => v.id).join(',')
            //判断是上架还是下架
            if (this.unPublish) {
              // 下架
              var param = {'houseIds':houseIds}
              unPubHouseToZwZhao(param).then((res) =>{
                if (res&&res.code != '200'){
                  this.$Message.error(res.msg)
                }else {
                  next()
                }
              })
            } else {
              // 上架
              batchPublishZwZhao(houseIds).then((res)=>{
                if (res&&res.code != '200'){
                  this.$Message.error(res.msg)
                }else {
                  next()
                }
              })
            }

          }


        })
    },
    methods: {
        buildChannelList(){
          var channelArray = new Array()

          var channelZhao = {}
          channelZhao.id = 2
          channelZhao.text = '住喔找房'
          channelZhao.value = 2
          channelArray.push(channelZhao)

          var channelChu = {}
          channelChu.id = 1
          channelChu.text = '住喔出房'
          channelChu.value = 1
          channelArray.push(channelChu)

          this.channelList = channelArray
        },
        normalizeHouseList(list) {
            return list.map((v) => {
                var item = { ...v }

                item.fee = 20
                item.feeText = currency(item.fee)
                item.rentText = currency(item.rent)
                item.commissionText = currency(item.commission)
                item.errorMessage = ''

                return item
            })
        },
        formula(model) {
            // 校验
            model.verification(
                (d) => d.key == 'houseName',
                (d) => [
                    {
                        validator(rule, value, callback, source, options) {
                            if (d.row.errorMessage) {
                                return callback(new Error(d.row.errorMessage))
                            }
                            // if (!d.row.factitle) {
                            //     return callback(new Error('房间配置不能为空'))
                            // }
                            if (!d.row.tags) {
                                return callback(new Error('标签不能为空'))
                            }
                            if (!d.row.commission) {
                                return callback(new Error('佣金必填'))
                            }
                            // if (!d.row.commissionRemark) {
                            //     return callback(new Error('佣金说明必填'))
                            // }
                            if (!d.row.attachments) {
                                return callback(new Error('图片必填'))
                            }

                            return callback()
                        },
                    },
                ]
            )
        },
        onHouseChange(ids, options) {
            console.log(options)
            this.selection = this.normalizeHouseList(options)
        },
        onRowDel(row, index) {
            this.selection.splice(index, 1)
        },
    },
}
</script>

<style lang="less">
.rp {
    &-title {
        margin: 12px 0;
        font-size: 18px;
    }

    &-fe {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid @border-color-base;

        td {
            padding: 0 8px;
            line-height: 44px;
        }

        tr {
            border-bottom: 1px solid @border-color-base;
        }

        &-num {
            text-align: right;

            &.is-neg {
                color: red;
            }
        }

        &-sum {
            font-size: 16px;
        }
    }
}
</style>
